/* ============================================================
   Bundle Sample, bundle-sample.js
   ============================================================ */

class BundleSample {
  constructor() {
    this.state = {
      deals:        [],   // parsed from DOM: { qty, el }
      activeDeal:   null, // { qty, el }
      slots:        [],   // array of slot objects | null  (length = activeDeal.qty)
      products:     []
    };

    this.collectionHandle = document.getElementById('bs-product-list')?.dataset.collection || '';

    this._initDeals();
    this._bindUI();
    this._fetchProducts();
  }

  /* ── Init ─────────────────────────────────────────────── */

  _initDeals() {
    const buttons = [...document.querySelectorAll('.bs-deal-btn')];
    this.state.deals = buttons.map(btn => ({
      el:        btn,
      qty:       parseInt(btn.dataset.quantity) || 0,
      price:     parseFloat(btn.dataset.price)  || 0,
      variantId: btn.dataset.variantId || ''
    }));

    if (!this.state.deals.length) return;

    // Check URL for a requested pack size (?pack=5 or ?pack=10)
const urlParams    = new URLSearchParams(window.location.search);
const requestedQty = parseInt(urlParams.get('pack')) || null;

const defaultDeal = this.state.deals.find(d => d.qty === requestedQty)
                  || this.state.deals.find(d => d.qty === 5)
                  || this.state.deals[0];
    this._selectDeal(defaultDeal);

    document.getElementById('bs-mobile-footer')?.classList.add('bs-mobile-footer--visible');
  }

  /* ── Deal Selection ───────────────────────────────────── */

  _selectDeal(deal) {
    this.state.activeDeal = deal;

    // Preserve filled slots when shrinking, expand with nulls when growing
    const prevSlots = this.state.slots;
    this.state.slots = Array.from({ length: deal.qty }, (_, i) => prevSlots[i] || null);

    const titleEl = document.getElementById('bs-deal-title');
    if (titleEl) titleEl.textContent = `Pack of ${deal.qty} Samples – £${deal.price}`;

    document.querySelectorAll('.bs-deal-btn').forEach(b =>
      b.classList.toggle('bs-deal-btn--active', b === deal.el)
    );

    this._renderGrid();
    this._renderSlots();
    this._refreshBuyBtns();
  }

  /* ── Products ─────────────────────────────────────────── */

  async _fetchProducts() {
    const list = document.getElementById('bs-product-list');
    if (!this.collectionHandle || !list) return;

    try {
      const res  = await fetch(`/collections/${this.collectionHandle}/products.json?limit=250`);
      const data = await res.json();
      this.state.products = data.products || [];
      this._renderGrid();
    } catch {
      list.innerHTML = '<p class="bs-error">Could not load products. Please refresh the page.</p>';
    }
  }

  /* ── Product Grid ─────────────────────────────────────── */

  _renderGrid() {
    const list = document.getElementById('bs-product-list');
    if (!list) return;

    if (!this.state.products.length) return; // still loading

    const isFull = this.state.slots.every(Boolean);

    if (!this.state.products.length) {
      list.innerHTML = '<p class="bs-error">No products found.</p>';
      return;
    }

    list.innerHTML = `<div class="bs-product-grid">${this.state.products.map(p => this._cardHTML(p, isFull)).join('')}</div>`;

    list.querySelectorAll('.bs-pcard__add-btn[data-pid]').forEach(btn => {
      btn.addEventListener('click', () => {
        const product = this.state.products.find(p => String(p.id) === btn.dataset.pid);
        if (product) this._handleAdd(product);
      });
    });

    list.querySelectorAll('.bs-pcard__details[data-handle]').forEach(btn => {
      btn.addEventListener('click', () => {
        window.open(`/products/${btn.dataset.handle}`, '_blank', 'noopener');
      });
    });
  }

  _cardHTML(p, isFull) {
    const count      = this.state.slots.filter(s => s?.productTitle === p.title).length;
    const img        = p.images?.[0]?.src || '';
    const allSoldOut = p.variants.every(v => !v.available);
    const disabled   = (isFull && count === 0) || allSoldOut;

    let btnLabel = 'Add';
    let btnClass = 'bs-pcard__add-btn';
    if (allSoldOut)  { btnLabel = 'Sold Out';  btnClass += ' bs-pcard__add-btn--soldout'; }
    else if (isFull) { btnLabel = 'Pack Full'; btnClass += ' bs-pcard__add-btn--full'; }

    return `
      <div class="bs-pcard" data-product-id="${p.id}">
        <div class="bs-pcard__image">
          ${img ? `<img src="${img}" alt="${this._esc(p.title)}" loading="lazy">` : ''}
        </div>
        <div class="bs-pcard__info">
          <p class="bs-pcard__name">${this._esc(p.title)}</p>
          <hr class="bs-pcard__divider">
          <button class="bs-pcard__details" data-handle="${p.handle}" type="button">See Details</button>
          <div class="bs-pcard__add-wrap">
            <button
              class="${btnClass}"
              type="button"
              data-pid="${p.id}"
              ${disabled ? 'disabled' : ''}
            >${btnLabel}</button>
            ${count > 0 ? `<span class="bs-pcard__count">${count}</span>` : ''}
          </div>
        </div>
      </div>`;
  }

  /* ── Add / Remove Logic (single variant only — no size drawer) ── */

  _handleAdd(product) {
    if (this.state.slots.every(Boolean)) return;

    const v = product.variants.find(v => v.available);
    if (!v) return;

    this._addToSlot({
      variantId:    v.id,
      productTitle: product.title,
      image:        product.images?.[0]?.src || '',
      handle:       product.handle
    });
  }

  _addToSlot(item) {
    const idx = this.state.slots.indexOf(null);
    if (idx === -1) return;
    this.state.slots[idx] = item;
    this._refreshUI();
  }

  _removeFromSlot(index) {
    if (index < 0 || index >= this.state.slots.length) return;
    this.state.slots[index] = null;
    this._refreshUI();
  }

  _removeLastOfVariant(variantId) {
    for (let i = this.state.slots.length - 1; i >= 0; i--) {
      if (this.state.slots[i]?.variantId === variantId) {
        this.state.slots[i] = null;
        this._refreshUI();
        return;
      }
    }
  }

  /* ── Refresh All UI ───────────────────────────────────── */

  _refreshUI() {
    this._renderSlots();
    this._renderGrid();
    this._renderMobileItems();
    this._refreshBuyBtns();
  }

  /* ── Desktop Slots ────────────────────────────────────── */

  _renderSlots() {
    const el = document.getElementById('bs-slots');
    if (!el) return;

    el.innerHTML = this.state.slots.map((slot, i) => {
      if (!slot) {
        return `<div class="bs-slot bs-slot--empty">
          <span class="bs-slot__placeholder">Sample goes here!</span>
        </div>`;
      }
      return `<div class="bs-slot bs-slot--filled">
        ${slot.image
          ? `<img class="bs-slot__thumb" src="${this._esc(slot.image)}" alt="${this._esc(slot.productTitle)}">`
          : '<div class="bs-slot__thumb"></div>'}
        <div class="bs-slot__info">
          <div class="bs-slot__name">${this._esc(slot.productTitle)}</div>
        </div>
        <button class="bs-slot__remove" type="button" data-idx="${i}" aria-label="Remove">&#10005;</button>
      </div>`;
    }).join('');

    el.querySelectorAll('.bs-slot__remove').forEach(btn => {
      btn.addEventListener('click', () => this._removeFromSlot(parseInt(btn.dataset.idx)));
    });
  }

  /* ── Mobile Bundle List ───────────────────────────────── */

  _renderMobileItems() {
    const el = document.getElementById('bs-mobile-items');
    if (!el) return;

    const grouped = new Map();
    this.state.slots.forEach(slot => {
      if (!slot) return;
      const key = slot.variantId;
      const g   = grouped.get(key);
      if (g) g.count++;
      else grouped.set(key, { slot, count: 1 });
    });

    if (!grouped.size) {
      el.innerHTML = '<p style="text-align:center;padding:16px;color:#999;font-size:13px">No items added yet</p>';
      return;
    }

    el.innerHTML = [...grouped.entries()].map(([vid, { slot, count }]) => `
      <div class="bs-mobile-item">
        ${slot.image
          ? `<img class="bs-mobile-item__thumb" src="${this._esc(slot.image)}" alt="${this._esc(slot.productTitle)}">`
          : '<div class="bs-mobile-item__thumb"></div>'}
        <div class="bs-mobile-item__label">
          <div class="bs-mobile-item__name">${this._esc(slot.productTitle)}</div>
        </div>
        <div class="bs-mobile-stepper">
          <button class="bs-mobile-stepper__btn" data-vid="${vid}" data-action="dec" type="button">&#8722;</button>
          <span class="bs-mobile-stepper__qty">${count}</span>
          <button class="bs-mobile-stepper__btn" data-vid="${vid}" data-action="inc" type="button">+</button>
        </div>
      </div>
    `).join('');

    el.querySelectorAll('.bs-mobile-stepper__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const vid = parseInt(btn.dataset.vid);
        if (btn.dataset.action === 'dec') {
          this._removeLastOfVariant(vid);
        } else if (!this.state.slots.every(Boolean)) {
          const existing = this.state.slots.find(s => s?.variantId === vid);
          if (existing) this._addToSlot({ ...existing });
        }
      });
    });
  }

  /* ── Buy Buttons ──────────────────────────────────────── */

  _refreshBuyBtns() {
    const deal   = this.state.activeDeal;
    const filled = this.state.slots.filter(Boolean).length;
    const total  = deal?.qty || 0;
    const isDone = filled === total && total > 0;
    const remain = total - filled;

    const label       = isDone ? 'Add to Cart' : `Add ${remain} more`;
    const mobileLabel = isDone ? 'Add To Cart' : `Add ${remain} more`;

    const desktopBtn = document.getElementById('bs-add-to-cart-btn');
    if (desktopBtn) {
      desktopBtn.textContent = label;
      desktopBtn.disabled    = !isDone;
    }

    const mobileBtn = document.getElementById('bs-mobile-add-btn');
    if (mobileBtn) {
      mobileBtn.textContent = mobileLabel;
      mobileBtn.disabled    = !isDone;
    }

    const toggleText = document.getElementById('bs-mobile-toggle-text');
    if (toggleText) toggleText.textContent = `View Your (${total} pack)`;
  }

  /* ── Add to Cart (single bundle-product line item, with chosen scents as a property) ─── */

  async _addToCart() {
    const desktopBtn = document.getElementById('bs-add-to-cart-btn');
    const mobileBtn  = document.getElementById('bs-mobile-add-btn');

    const deal = this.state.activeDeal;

    if (!deal?.variantId) {
      alert('This pack is not available yet. Please choose another option.');
      return;
    }

    [desktopBtn, mobileBtn].forEach(b => {
      if (b) { b.textContent = 'Adding\u2026'; b.disabled = true; }
    });

    // Build a readable list of chosen scents for the packing team
    const chosenScents = this.state.slots
      .filter(Boolean)
      .map((s, i) => `${i + 1}. ${s.productTitle}`)
      .join('\n');

    const items = [{
      id:         deal.variantId,
      quantity:   1,
      properties: { 'Selected Scents': chosenScents }
    }];

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Cart error');
      window.location.href = window.bsBundleData?.cartUrl || '/cart';
    } catch {
      alert('Sorry, something went wrong. Please try again.');
      this._refreshBuyBtns();
    }
  }

  /* ── UI Bindings ──────────────────────────────────────── */

  _bindUI() {
    document.getElementById('bs-deal-btns')?.addEventListener('click', e => {
      const btn  = e.target.closest('.bs-deal-btn');
      if (!btn) return;
      const deal = this.state.deals.find(d => d.el === btn);
      if (deal) this._selectDeal(deal);
    });

    ['bs-add-to-cart-btn', 'bs-mobile-add-btn'].forEach(id => {
      document.getElementById(id)?.addEventListener('click', () => this._addToCart());
    });

    document.getElementById('bs-mobile-toggle')?.addEventListener('click', () => {
      const bundle  = document.getElementById('bs-mobile-bundle');
      const chevron = document.getElementById('bs-mobile-toggle-chevron');
      const toggle  = document.getElementById('bs-mobile-toggle');
      if (!bundle) return;

      const isOpen = !bundle.hidden;
      bundle.hidden = isOpen;
      chevron?.classList.toggle('bs-mobile-toggle-chevron--open', !isOpen);
      toggle?.setAttribute('aria-expanded', String(!isOpen));

      if (!isOpen) this._renderMobileItems();
    });
  }

  /* ── Helpers ──────────────────────────────────────────── */

  _esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}

/* ── Boot ─────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('bundle-sample')) {
    window.bs = new BundleSample();
  }
});